import React from "react";

import { Stack, Typography } from "@mui/material";
import { DealStageItem } from "store/types";
import { useNavigate } from "hooks";
import { useAllowDealTabOpenSelector } from "store";
import { NavigateLink } from "components/Navigate-link/NavigateLink";

interface Props extends DealStageItem {}

export const OpportunitiesCard: React.FC<Props> = ({ id, title, asset_class }) => {
  const allowNewTab = useAllowDealTabOpenSelector();
  const navigate = useNavigate();

  return (
    <NavigateLink allowNewTab={allowNewTab} route="deal" params={{ deal_id: String(id) }}>
    <Stack
      gap="15px"
      sx={{
        bgcolor: "#0a31420d",
        borderRadius: "8px",
        p: "10px",
        height: "85px",
        cursor: "grab",
        userSelect: "none",
        WebkitUserSelect: "none",
        msUserSelect: "none",
        MozUserSelect: "none",
        "&:active": {
          cursor: "grabbing"
        },
        "& *": {
          userSelect: "none",
          WebkitUserSelect: "none",
          msUserSelect: "none",
          MozUserSelect: "none"
        }
      }}
      onClick={() => navigate({ route: "deal", params: { deal_id: id } })}
    >
      <Stack sx={{ gap: "4px", cursor: "pointer" }}>
        <Typography sx={{ lineHeight: 1, fontSize: "15px", color: "#0a3142" }}>{title}</Typography>
        <Typography sx={{ lineHeight: 1, fontSize: "13px", color: "#5d7782" }}>{asset_class}</Typography>
      </Stack>
    </Stack>
    </NavigateLink>
  );
};
